/**
 * WCAG - Skip to main content
 *
 * Moves keyboard/screen-reader focus directly to the <main> element
 * when the `.skip-to-main` button is activated.
 */
export default function initSkipToMain() {

	const trigger = document.querySelector( '.skip-to-main' );
	if ( ! trigger ) {

		return;

	}

	trigger.addEventListener( 'click', () => {

		const main = document.querySelector( 'main' );
		if ( main ) {

			main.tabIndex = -1;
			main.focus();

		}

	} );

}

